<script>
import Modal from "@/components/_Shared/Modal";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    Modal
  },

  data() {
    return {
      textSearch: "",
      selectedDistrict: null,
      results: [],
      loader: false,
      error: ""
    };
  },

  computed: {
    ...mapState("newAddress", ["district"])
  },

  methods: {
    ...mapActions("newAddress", ["searchDistrict", "setDistrict"]),
    async submit() {
      this.loader = true;

      try {
        if (this.textSearch.length < 3)
          throw "A busca deve conter ao menos 3 caracteres!";

        this.results = await this.searchDistrict(this.textSearch);
        this.error = "";
      } catch (e) {
        this.error =
          "Não encontramos um bairro com o nome informado. Confira o nome do bairro e caso o erro persista entre em contato com o nosso suporte para que possamos adicioná-lo a nossa base e você possa começar a receber limpezas!";
        this.selectedDistrict = null;
        this.results = [];
        this.$toasted.error(e);
      }

      this.loader = false;
    },

    selectDistrict(district) {
      this.selectedDistrict = district;
    },

    proceed() {
      try {
        if (!this.selectedDistrict) throw "Nenhum bairro selecionado!";
        this.setDistrict(this.selectedDistrict);

        this.$emit("next");
      } catch (e) {
        this.$toasted.error(e);
      }
    }
  },

  async mounted() {
    if (this.district) {
      this.textSearch = this.district.display_name;
      await this.submit();
    }
  }
};
</script>

<template>
  <modal title="QUASE LÁ!" subtitle="Vamos confirmar o seu bairro." size="md">
    <template slot="body">
      <div class="input-group">
        <input
          @keydown.enter="submit"
          type="text"
          v-model="textSearch"
          placeholder="digite o nome do seu bairro"
        />
        <div class="btn bg-pink" :class="{'btn--loading': loader}" @click="submit">
          <span>buscar</span>
        </div>
      </div>

      <div class="error" v-if="error">{{error}}</div>

      <div class="results" v-if="results.length">
        <span>Selecione um dos resultados abaixo:</span>
        <div
          v-for="(result, index) in results"
          :key="index"
          :class="{active: selectedDistrict && selectedDistrict.id == result.id }"
          @click="selectDistrict(result)"
        >{{result.display_name}}</div>
      </div>
    </template>

    <template slot="footer">
      <div class="btn bg-gray" @click="$emit('prev')">voltar</div>
      <button
        class="btn"
        :class="{'bg-purple': selectedDistrict}"
        :disabled="!selectedDistrict"
        @click="proceed"
      >confirmar e prosseguir</button>
    </template>
  </modal>
</template>

<style scoped>
input {
  border: 1px solid #ddd;
  flex: 1;
  height: 38px;
  border-radius: 4px;
  padding-left: 10px;
}

.error {
  border-left: 2px solid var(--pink);
  font-size: 14px;
  color: var(--pink);
  margin: 10px;
  padding-left: 10px;
}

.input-group {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

p {
  font-size: 14px;
}

.results {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 5px;
}

.results span {
  width: 100%;
  font-size: 12px;
  color: var(--pink);
  flex-grow: 1;
}

.results div {
  padding: 10px;
  border-radius: 5px;
  background-color: #eee;
  font-size: 14px;
  margin: 5px 10px 5px 0;
  cursor: pointer;
  transition: all 0.24s ease;
}

.results div:hover {
  color: var(--pink);
  background-color: var(--pink-off-white);
}

.results div.active {
  background-color: var(--pink);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Addresses/NewAddress/SelectDistrict.vue